module.exports = __webpack_public_path__ + "static/img/1.1df603e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/sp/1.png
// module id = WF7G
// module chunks = 0